/**
 * WordPress admin-ajax transport (platform layer)
 *
 * Fallback transport for shops whose REST API is blocked. jQuery.ajax is
 * used deliberately: its nested form-data encoding is exactly what the PHP
 * side reads from $_POST, and this file only ever runs on WordPress.
 *
 * @since 1.65.0
 */

(function (pmw, $, undefined) {

	/**
	 * POST to admin-ajax.php in the shape all PMW ajax handlers expect.
	 *
	 * @param {object} options
	 * @param {string} options.action  WordPress ajax action name
	 * @param {object} options.data    Payload, becomes $_POST['data']
	 * @param {Function} [options.success]
	 * @param {Function} [options.error]
	 * @returns {void}
	 */
	pmw.wpAjaxPost = ({action, data, success, error}) => {
		$.ajax({
			type    : "post",
			dataType: "json",
			url     : pmw.ajax_url,
			data    : {
				action: action,
				data  : data,
			},
			// This file loads before functions_loader.js wires up pmw.console,
			// so the default handlers cannot assume it is there.
			//
			// @since 1.67.1
			success : success || (message => pmw.console?.log(message)),
			error   : error || (message => pmw.console?.error(message)),
		})
	}

}(window.pmw = window.pmw || {}, jQuery));
